import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Role} from '../models/role';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {Observable, finalize, map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContriesService {

  constructor (private db: AngularFirestore,
    private fs: AngularFireStorage) { }

  select (): Observable<any[]> {
    return this.db.collection<any>('sbccv_countries').snapshotChanges().pipe(
      map(changes => changes.map(change => ({
        ...change.payload.doc.data(),
        id: change.payload.doc.id,
      })))
    );
  }

  async getById (id) {
    try {
      const getResult: any = this.db.doc<any>('sbccv_countries/' + id)
        .get();

      return {
        ...getResult.data(),
        'id': getResult.id,
      }
    } catch (error) {
      console.error("Erro getById countries: ", error);
      throw error;
    }

  }

  insert (entity: Role) {
    try {
      return this.db.collection('sbccv_countries').add(Object.assign({}, entity));
    } catch (error) {
      console.error("Erro insert countries: ", error);
      throw error;
    }
  }

  update (entity: Role) {
    try {
      return this.db.collection('sbccv_countries').doc(entity.id).set(Object.assign({}, entity));
    } catch (error) {
      console.error("Erro updatee countries: ", error);
      throw error;
    }
  }

  delete (entity_id: any) {
    try {
      return this.db.collection('sbccv_countries').doc(entity_id).delete();
    } catch (error) {
      console.error("Erro delete country: ", error);
      throw error;
    }
  }

  uploadImage (file: any, id: string) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/countries/" + id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(id, url)
        });
      }))
      .subscribe();
  }

  private async updateImage (id: any, image: any) {
    try {
      await this.db.collection('sbccv_countries').doc(id).set({image: image}, {merge: true});
      // this.objectImage = "";
    } catch (err) {
      console.log("erro upadate country image: " + JSON.stringify(err));
    }
  }

  async deleteFileInStorage (src: string): Promise<void> {
    if (!src) {
      return;
    }

    try {
      const fsRef = this.fs.storage.refFromURL(src);
      await fsRef.delete();
    } catch (error) {
      console.error('Erro ao excluir arquivo do Storage: ', error);
      throw error;
    }
  }

}
